import React, { Fragment } from "react";
import PatientLoader from "../../../common/PatientLoader";
import PatientActionButton from "./PatientActionButton";
import NotesElement from "./NotesElement";
import { ReactComponent as UpdateProfile } from "../../../../assets/icons/UpdateProfile.svg";

const PatientNotesCard = ({
  setWalkInOffCanvasStatus,
  setPatientNotesTab,
  patientNotesLoading,
  patientNotesData,
  loading,
  showUpdateButton,
}) => {
  const notes = [...patientNotesData];
  return (
    <div className="container-fluid notes-card mt-2">
      {loading ? (
        <PatientLoader />
      ) : (
        <>
          <div className="container-fluid d-flex justify-content-between mb-3">
            <div
              className="d-flex justify-content-start"
              style={{ gap: "10px" }}
            >
              <UpdateProfile fill="#395e9d" style={{ marginTop: "2%" }} />
              <h6>
                Recent Patient Notes (
                {(patientNotesData && patientNotesData?.length) || 0})
              </h6>
            </div>
            <PatientActionButton
              icon={<UpdateProfile fill="#2D6A2B" />}
              text={"Update"}
              callBack={() => {
                setWalkInOffCanvasStatus(true);
              }}
              styles={{ color: "#2D6A2B", backgroundColor: "#eafff5" }}
            />
            {/* {showUpdateButton ? (
              <PatientActionButton
                icon={<UpdateProfile fill="#2D6A2B" />}
                text={"Update"}
                callBack={() => {
                  setWalkInOffCanvasStatus(true);
                }}
                styles={{ color: "#2D6A2B", backgroundColor: "#eafff5" }}
              />
            ) : (
              <Fragment />
            )} */}
          </div>
          <div className="container-fluid m-0">
            {patientNotesLoading ? (
              <PatientLoader />
            ) : (
              <>
                {notes &&
                  notes?.length > 0 &&
                  notes.splice(0, 2).map((note) => {
                    return <NotesElement key={note.id} data={note} />;
                  })}
              </>
            )}
          </div>
          <div className="container-fluid text-center mt-3">
            <small
              style={{
                color: "#395E9D",
                textDecoration: "underline",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={() => {
                setPatientNotesTab();
              }}
            >
              View All Notes {">"}
            </small>
          </div>
        </>
      )}
    </div>
  );
};

export default PatientNotesCard;
